import { Reducer } from "redux";

import { GetNotificationsListDispatchTypes } from "../models/dispatchTypes/Referral";
import { HeaderNotificationListResponse } from "../models/api/Referral";
import { GetNotificationsListActionDispatchTypes } from "../constants/Referral";

const initialState: HeaderNotificationListResponse = {
    loading: false,
    response: {
        userId: "",
        badgeCount: 0,
        notifications: [],
    },
    error: null,
};

const HeadersNotificationListReducer: Reducer<
    HeaderNotificationListResponse,
    GetNotificationsListDispatchTypes
> = (state = initialState, action) => {
    switch (action.type) {
        case GetNotificationsListActionDispatchTypes.GET_NOTIFICATIONS_LIST_INVOKE: {
            return {
                ...state,
                loading: true,
            };
        }
        case GetNotificationsListActionDispatchTypes.GET_NOTIFICATIONS_LIST_SUCCESS: {
            return {
                ...state,
                response: action.response,
                loading: false,
            };
        }
        case GetNotificationsListActionDispatchTypes.GET_NOTIFICATIONS_LIST_ERROR: {
            return {
                ...state,
                error: action.error,
                loading: false,
            };
        }
        case GetNotificationsListActionDispatchTypes.GET_NOTIFICATIONS_LIST_RESET: {
            return initialState;
        }
    }
    return state;
};
export default HeadersNotificationListReducer;
